ENTER_ANIMATION_DURATION = 150
EXIT_ANIMATION_DURATION  = 150

App.SmMiniPopupComponent = Em.Component.extend
  classNames: [ 'sm-mini-popup' ]
  classNameBindings: [ 'isPopupCurrent:-dummy']

  name: null

  currentPopup: Em.computed.oneWay('parentView.currentPopup')

  isPopupCurrent: (->
    @get('currentPopup') is @get('name')
  ).property('currentPopup')

  isPopupActive: false

  addHiddenClass: (->
    @$().addClass('-hidden')
  ).on('didInsertElement')

  _isCurrentChanged: (->
    was   = @get('isPopupCurrentWas')
    value = @get('isPopupCurrent')

    @set('isPopupCurrentWas', value)

    if was is value
      return

    $elem = @$()

    if value
      $elem.addClass('-enter-animation')
      $elem.removeClass('-hidden')
      @set('isPopupActive', true)

      Em.run.cancel(@get('lastAnim')) if @get('lastAnim')

      @set 'lastAnim', Em.run.later =>
        $elem.addClass('-run')

        @set 'lastAnim', Em.run.later =>
          $elem.removeClass('-enter-animation -exit-animation -run')
        , ENTER_ANIMATION_DURATION
      , 30
    else
      $elem.addClass('-exit-animation')
      Em.run.cancel(@get('lastAnim')) if @get('lastAnim')

      @set 'lastAnim', Em.run.later =>
        $elem.addClass('-run')

        @set 'lastAnim', Em.run.later =>
          $elem.removeClass('-enter-animation -exit-animation -run')
          $elem.addClass('-hidden')
          @set('isPopupActive', false)
        , EXIT_ANIMATION_DURATION
      , 10

  ).observes('isPopupCurrent')